import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { UserManagementModel } from "api";
import { useCustomerService } from "contexts/ServiceContext";
import { SORT_DIRECTION } from "hooks/useSort";
import { ApiStatusException } from "services/apiErrors";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

export const USER_MANAGEMENT_QUERY_KEY = "user-management";

export const useUserManagementRoles = (
  cardCode: string | undefined,
  searchTerm?: string,
  activeSort?: { direction: SORT_DIRECTION; key: string }
): UseQueryResult<UserManagementDetails[]> => {
  const customerService = useCustomerService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST);
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR);

  return useQuery({
    queryKey: [
      USER_MANAGEMENT_QUERY_KEY,
      { filters: { cardCode, searchTerm, activeSort } },
    ],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "api/UserManagement",
      });
      return cardCode
        ? customerService
            .getUserManagementRoles(
              cardCode,
              searchTerm,
              activeSort as {
                direction: SORT_DIRECTION;
                key: keyof UserManagementModel;
              }
            )
            .catch((err: ApiStatusException) => {
              trackQueryError(
                {
                  statusCode: err.statusCode as number,
                  message: err.message,
                },
                eventId
              );
              throw err;
            })
        : Promise.reject();
    },
    enabled: !!cardCode,
    keepPreviousData: true,
    select: (data) => data.value,
  });
};

export default useUserManagementRoles;
